import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import useAbsencePlannerStateContext from 'pages/AbsencePlanner/contexts/AbsencePlannerStateContext'
import SideMenuButton from 'redesign/components/atoms/Buttons/side-menu-button'
import HeaderLabel from 'redesign/components/molecules/HeaderLabel'
import { useSideMenuContext } from 'redesign/services/SideMenu/useSideMenuContext'
import Header from '../../Header'

const AbsencePlannerHeader: React.FC = () => {
  const { t } = useFavurTranslation()
  const { setOpen } = useSideMenuContext()
  const { isSmallScreen } = useAbsencePlannerStateContext()

  return (
    <Header
      middleContent={<HeaderLabel mainText={t('page.absencePlanner.title')} />}
      endContent={isSmallScreen && <SideMenuButton onClick={() => setOpen(true)} />}
      withoutDivider={isSmallScreen}
    />
  )
}

export default AbsencePlannerHeader
